<template>
  <v-row>
    <v-col>
      <v-data-table
        :headers="header"
        :items="data"
        hide-default-footer
        class="elevation-2 fix-font"
        sort-by="order"
        :sortDesc="true"
        mobile-breakpoint="0"
        :items-per-page="-1"
        hide-default-header
      >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th
                v-for="item in headers"
                :key="item.name"
                class="text-center text-body-1"
              >
                {{ item.text }}
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.name" class="text-center">
              <td>{{ item.order }}</td>
              <td>{{ item.createDate }}</td>
              <td>{{ item.time }}</td>
              <td>{{ item.officer ? item.officer : '-' }}</td>
              <td>{{ item.process }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['data', 'header']
}
</script>

<style scoped>
.fix-font {
  white-space: nowrap;
}
</style>
